import { IVoucherHolder } from '@nkr/models/action-center/voucher-donor';
import { IDonorCompliance } from '@nkr/models/donor-compliance';
import { IRecipient } from '../recipient';
import { PatientType } from '@nkr/enums/index';

export interface ISwapDonor {
    donorId: number,
    centerId: number,
    centerAlias: string,
    donationCenterId: number,
    typeId: number,
    donorType: number,
    fullName: string,
    email: string,
    mrn: string,
    unosId: string,
    alias: string,
    gender: string,
    age: number,
    bloodType: string,
    statusId: number,
    registered: string,
    donated: string,
    donorCoordinator: number
    dateOfEvaluation: string,
    donationStartDate: string,
    donationEndDate: string,
    canDonateFrom: string,
    directCryoSend: boolean,
    directXmSend: boolean,
    directSerologySend: boolean,
    vialsAtNkrLab: number,
    status: string,
    registrationId: number,
    rdnCenterId: number,
    isRemoteDirect: boolean,
    isActive: boolean,
    isExportable: boolean,
    isAdp: boolean,
    isDeleted: boolean,
    isTransplanted: boolean,
    canDelete: boolean,
    wageAndTravelRequested: boolean,
    donationTypeId: number,
    donationType: string,
    donationTypeAbbr: string,
    adpVoucherHolders: IVoucherHolder[],
    donorCompliance: IDonorCompliance,
    exportabilityValidationResults: string[],
    vouchersComplete: boolean,
    isInDonorFollowUpProgram: boolean,
    sendComplianceEmails: boolean,
    firstExportableDate: string,
    birthDate: string,
    isPaired: boolean,
    hasVoucherRecipient: boolean,
    hasIntended: boolean,
    isExpertSystem: boolean,
    canConvert: boolean,
    originalFromDate: string,
    originalToDate: string,
    donorChainId: number,
    clusterNumber: number,
    position: number,
    adpRecipientId: number,
    adpRecipientAlias: string,
    recipientId: number,
    recipientCenterId: number,
    remoteRecipientCenter: string
    recipientAlias: string,
    recipientType: PatientType,
    canOrderCheekSwab: boolean,
    requisitionId: number,
    expertSystemStatusId: number,
    isRealTimeSwapFailure: boolean,
    isAddBackCredit: boolean,
    addBackCreditChangeReason: string
}